// Meta Pixel event helper. Browser-side only — no Conversions API.
//
// Call sites use this instead of touching `window.fbq` directly so a missing/blocked Pixel
// (env var unset, consent rejected, ad blocker) is always a silent no-op rather than a
// runtime error that could break the quiz flow.

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
  }
}

/** Custom event names — kept as constants so call sites can't typo them. `PageView` is a
 * Meta standard event and is fired directly by `components/analytics/MetaPixel.tsx`. */
export const META_PIXEL_EVENT = {
  quizStart: "QuizStart",
  quizComplete: "QuizComplete",
} as const;

export type MetaPixelEventName = (typeof META_PIXEL_EVENT)[keyof typeof META_PIXEL_EVENT];

export function trackMetaEvent(name: MetaPixelEventName, params?: Record<string, unknown>): void {
  if (typeof window === "undefined") return;
  try {
    window.fbq?.("trackCustom", name, params);
  } catch {
    // Tracking must never break the app it's tracking.
  }
}
